<template>
  <div class="">
    <div class="">
         <div class="create-new-test">
        <div class="text-center btn-align">
          <div class="btn-index">
            <v-btn
              class="right-btn cust-btn"
              color="primary"
              @click="onUpload"
              :disabled="!isOnlineOfflineTest.isOffline"
            >
              Upload OMR
            </v-btn>
          </div>
         
        </div>
      </div>
     
      <v-card class="mx-auto normal-card">
        <div class="data-table-section CustomizedTest prev-test-tb cat-44">
          <v-data-table
            :headers="tab=='AITS' ? headersAITS : headers"
            fixed-header
            :items="items"
            hide-default-header
            hide-default-footer
            class="elevation-2 cust-table"
          >
            <template v-slot:header="{ props: { headers } }">
              <TableHeader
                :headers="tab==='AITS' ? headersAITS : headers"
                :onHeaderAction="onHeaderAction"
                :orderBy="orderBy"
                :onSortChange="onSortChange"
              />
            
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  class="cursor-pointer"
                  style="position: relative"
                  v-for="(item, index) in items"
                  :key="item.id"
                  :disabled="buttonHovering == index"
                  v-on:mouseover="buttonHovering = index"
                  v-on:mouseleave="buttonHovering = -1"
                  @click="buttonHovering = index"
                >
                  <td
                    class="text-center fix-130 cursor-pointer"
                    @click.prevent="onPreviewClick(item)"
                  >
                    <div v-if="buttonHovering == index">
                      <div
                        class="v-tooltip__content cust-new-tooltip-top open-top"
                        style="
                          left: 10px;
                          opacity: 0;
                          top: auto;
                          z-index: 9999;
                          bottom: 45px;
                        "
                      >
                        <div
                          :class="getCreateTestStatusClass(item)"
                          @click="retryTestDialog(item)"
                          class="assignment-text"
                        >
                          Test Making
                          {{ getTestCreationStatusText(item) }}
                        </div>
                      </div>
                    </div>
                    <div>{{ (item.omr_pattern_id && item.id) || "N.A" }}</div>
                  </td>
                  <td class="fix-130 cursor-pointer">
                    <div v-if="item.editTestName">
                      <v-text-field
                        @keyup.enter="saveTestName(item)"
                        @blur="saveTestName(item)"
                        v-model="item.test_name"
                        autofocus="autofocus"
                        dense
                        hide-details
                      ></v-text-field>
                    </div>
                    <div
                      v-else
                      @click="onPreviewClick(item)"
                    >
                      {{ item.test_name }}
                    </div>
                  </td>
                  <td v-if="tab!='AITS'"
                    class="dint-120-test cursor-pointer"
                    @click="onPreviewClick(item)"
                  >
                    {{ getFormatedDate(item.created_at) }}
                  </td>
                  <td v-if="tab!='AITS' && !CONSTANTS_REF.AITS_INSTITUTE_ID.includes(instituteId)"
                    class="text-center cursor-pointer"
                    @click="onPreviewClick(item)"
                  >
                    {{ item.subjects_sf }}
                  </td>
                  <td class="duration-display cursor-pointer">
                    {{ item.duration }}
                  </td>
                  <td v-if="tab==='AITS'"
                    class="dint-120-test cursor-pointer"
                    @click="onPreviewClick(item)"
                     style="text-align:left;"
                  >
                    <span style="font-weight:700;">{{ getFormatedDate(item.shared_omr_publish_time) }}</span><br>
                    <span>{{getFormatedTime(item.shared_omr_publish_time)}}</span>
                  </td>
                  <td v-if="tab==='AITS'"
                    class="dint-120-test cursor-pointer"
                    style="text-align:left;"
                    @click="onPreviewClick(item)"
                  >
                    <span style="font-weight:700;">{{ getFormatedDate(item.shared_omr_upload_time)}}</span><br>
                    <span>{{getFormatedTime(item.shared_omr_upload_time)}}</span>
                  </td>
                   <td
                    class="dint-120 cursor-pointer"
                    v-if="(!checkUserType(roleIds.ED) && !CONSTANTS_REF.AITS_INSTITUTE_ID.includes(instituteId))"
                  >
                    <div
                      @click="(item.test_create_status === TEST_STATUS.IN_PROGRESS || item.test_create_status === TEST_STATUS.FAILED || !showScheduleButton) ? null : ScheduleTestDialog(item)"
                      class="Schedule"
                      :class="{ 'disabled': item.test_create_status === TEST_STATUS.IN_PROGRESS || item.test_create_status === TEST_STATUS.FAILED || !showScheduleButton }"
                    >
                      {{showScheduleButton ? 'Schedule' : ''}}
                    </div>
                  </td> 
                 <td
                    class="dint-120 cursor-pointer"
                    v-else
                  >
                    <template v-if="item.is_shared_test">
                      <v-tooltip 
                          left
                          bottom
                          content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                          >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            @click="ShareTestDialog(item)"
                            class="Schedule"
                            :class="getStatusClass(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="
                              item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                              item.test_create_status === TEST_STATUS.FAILED
                            "
                          >
                            {{ getAitsTestStatusText(item)}}
                          </div>
                        </template>
                        <span
                        class="text-center tool-tip-position">
                          <b>Shared test window: </b><br>
                         Start time: {{ formatDate(item.shared_start_time) }} <br>End time:{{ formatDate(item.shared_end_time) }}
                        </span>
                      </v-tooltip>
                    </template>
                    <div
                      v-else
                      @click="ShareTestDialog(item)"
                      class="Schedule"
                      :class="{ 'blue-share': !(item.test_create_status === TEST_STATUS.IN_PROGRESS || item.test_create_status === TEST_STATUS.FAILED) }"
                      :disabled="
                        item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                        item.test_create_status === TEST_STATUS.FAILED
                      "
                    >
                      {{ "Share" }}
                    </div>
                  </td>
                   <td class="text-center cursor-pointer download-icon">
                    <v-img class="loader-img" src="../../../assets/img/loading.gif" v-if="item.status === downloadStatus.IN_PROGRESS"
                    ></v-img>
                    <v-btn
                      v-else
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTest(item)"
                      :disabled="
                        item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                          item.test_create_status === TEST_STATUS.FAILED
                      "
                    >
                      <v-img
                        width="23px"
                        src="../../../assets/img/download.svg"
                        
                      ></v-img>
                     
                    </v-btn>
                  </td>

                  <td
                    class="dint-127 cursor-pointer"
                    v-if="
                      (checkUserType(roleIds.ED) ||
                        checkUserType(roleIds.ID) ||
                        checkUserType(roleIds.CO)) && tab!='AITS'
                    "
                  >
                    <div
                      :class="getTestStatusClass(item)"
                      @click="assignTestDialog(item)"
                      class="assignment-text cursor-pointer"
                      :disabled="
                        item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                          item.test_create_status === TEST_STATUS.FAILED
                      "
                    >
                      {{ getTestStatusText(item) }}
                    </div>
                  </td>
                  <td v-if="(roleIds.ID == user.role_id) && tab!='AITS'" class="text-center">
                    <v-icon
                      :disabled="
                        item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                          item.delete_disable
                      "
                      @click="confirmDeleteTest(item)"
                      class="delete-btn-cp3  cursor-pointer"
                      title="Delete Test"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td class="text-center" v-if="tab!='AITS' && !CONSTANTS_REF.AITS_INSTITUTE_ID.includes(instituteId)">
                    <v-icon
                      @click="confirmDuplicateTest(item)"
                      title="Duplicate Test"
                      :disabled="
                        item.test_create_status === 2 ||
                          item.test_create_status === 3
                      "
                      class="duplicate-btn-cp3"
                    >
                      mdi-file-multiple
                    </v-icon>
                  </td>
                  <!-- </v-hover> -->
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </v-card>
      <div class="footer-btn">
        <div class="btm-test-prev-test text-italic mt-2" v-if="tab!='AITS'">
          Click on the Test ID or Test Name to Preview Test
        </div>
        <div class="pull-left"></div>
        <div class="pull-right">
          <Pagination
            :currentPage="currentPage"
            :totalPage="totalPages"
            :onPageChange="onPageChange"
          />
        </div>
      </div>
      <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertBoxData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import UpgradeTestModal from "@/components/coordinator/Tests/UpgradeTestModal.vue";
import { toRaw } from "vue";

let timeInterval = null;
export default {
  name: "AitsCustomized",
  components: { UpgradeTestModal },
  props: ["tab", "value", "isOnlineOfflineTest"],
  data() {
    return {
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      CONSTANTS_REF:constants,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      isAITS: false,
      instituteId:'',
      hasQPDAccess: false,
      hasSTAccess: false,
      showScheduleButton: false,
      aitsModule: false,
      headers: [],
      headersAITS: [
        {
          text: "Test ID",
          value: "id",
          class: "text-center fix-130",
        },
        {
          text: "Test Name",
          value: "test_name",
          class: "fix-130",
        },
       
        {
          text: "Duration\n(Mins)",
          align: "center",
          value: "duration-display",
          class: "text-center dint-120",
          hideSort: true,
        },
        { text: "Unlock Date Time", value: "publish_time" ,class: "fix-130", },
        { text: "OMR Upload Deadline", value: "omr_upload_time", class: "fix-130",},
        { text: "", value: "", type: "blank", class: "dint-120" },
        
      ],
      items: [],
      dialog: false,
      cComponent: "components/coordinator/Tests/ScheduleTestPopup",
      status: false,
      alertBoxData: {},
      selectedTest: null,
      modalwidth: "1000px",
      instituteType: "SILVER",
      currentTestName: "",
      testName: "",
      showUpgradeModal: false,
      modules: [],
      dummyOptions: [],
      dummyOptionsABC: [],
      dummyOptionsPQR: [],
      retryTestData: {},
      timeInterval: 0,
      TEST_STATUS: {},
      buttonHovering: false,
      showToolTip: false,
      hover: false,
      typetimeout: 0,
      popUpMessage: "This feature is only available for Premium Users.",
      singleClickTimer: null,
      downloadStatus: constants.DOWNLOAD_STATUS,
      requestIds: [],
      testStatusTimeout: 0,
      toasts:{}
    };
  },
  async created() {
    let instituteData = JSON.parse(localStorage.getItem("myInstitute"));
    let instId = instituteData?.id
    this.headers = [
        {
          text: "Test ID",
          value: "id",
          class: "text-center fix-130",
        },
        {
          text: "Test Name",
          value: "test_name",
          class: "fix-130",
        },
        { text: "Created On", value: "created_at", class: "dint-120-test" },
        ...(!constants.AITS_INSTITUTE_ID.includes(instId)
          ? [
              {
                text: "Subjects",
                value: "subjects",
                class: "text-center",
                hideSort: true,
              },
            ]
          : []),
        {
          text: "Duration\n(Mins)",
          align: "center",
          value: "duration-display",
          class: "text-center dint-120",
          hideSort: true,
        },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "" },
        { text: "", value: "", type: "blank", class: "" },
      ]
  },

  mounted() {
    this.getCurrentUser();
    this.checkModuleAccess();
    
    this.dummyOptions = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: this.DUMMYTEXT,
        correct_answer: true,
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: this.DUMMYTEXT,
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[2],
        option_text: this.DUMMYTEXT,
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[3],
        option_text: this.DUMMYTEXT,
        correct_answer: false,
      },
    ];
    this.dummyOptionsABC = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: this.DUMMYTEXT,
        column: 1,
        correct_answer: "P",
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: this.DUMMYTEXT,
        column: 1,
        correct_answer: "P",
      },
    ];
    this.dummyOptionsPQR = [
      {
        index: this.OPTIONS_PQR[0],
        option_text: this.DUMMYTEXT,
        column: 2,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_PQR[1],
        option_text: this.DUMMYTEXT,
        column: 2,
        correct_answer: "",
      },
    ];
    this.getUserDetails();
    if (this.roleIds.ID == this.user.role_id) {
      this.headers.push({
        text: "",
        value: "",
        type: "blank",
        class: "",
      });
    }
    this.TEST_STATUS = constants.CUSTOM_TEST_STATUS;
    this.downloadStatus = constants.DOWNLOAD_STATUS;
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"]),
  },
  methods: {


    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    formatDate(dateString) {
    if (!dateString) return ""; 
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  },
  istestPreviewable(item) {
    const sharedOmrPublishTimeFormated = this.formatDate(item.shared_omr_publish_time)
    const sharedOmrPublishTime = new Date(item.shared_omr_publish_time);
    const currentDateTime = new Date();
    if (sharedOmrPublishTime < currentDateTime) {
      return false; 
    } else {
      this.$toasted.error(`You can not Open shared test before unlock time ${sharedOmrPublishTimeFormated} `);
      this.$root.showLoader = false;
      return true; 
      
    }
},
    ...mapActions({
      getTestList: "testStore/getTestList",
      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
      showLoader: "testStore/showLoader",
      me: "userStore/me",
      updateTestName: "testStore/updateTestName",
      createDuplicateTest: "testStore/createDuplicateTest",
      deleteTestById: "testStore/deleteTest",
      checkTestStatus: "testStore/checkTestStatus",
      customTestRetry: "testStore/customTestRetry",
      getCustomTestCount: "testStore/getCustomTestCount",
      uploadOmr: "testStore/uploadOmr",
      assignTest: "testStore/assignTest",
      saveInstituteTestDownload: 'testStore/saveInstituteTestDownload',
    }),

    confirmDuplicateTest(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `Are you sure you want to duplicate the test - ${item.test_name} ?`,
        refId: "duplicateTest",
      };
      this.modalwidth = "350px";
      this.status = true;
    },

    confirmationDialogBox(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `<strong style="color: #ff0000;font-size:16px">Warning:</strong></br>
You have not assigned all the subjects to teachers.
Please make sure you assign all subjects to be reviewed by teachers now.
You will not be able to assign the remaining subject(s) later.</br></br>

Do you want to proceed with partial assignment for review?`,
        refId: "assign-test",
      };
      this.modalwidth = "450px";
      this.status = true;
    },
    downloadTest(item) {
      // if (this.tab === 'Online') {

      //     let domainUrl = process.env.VUE_APP_API_URL;
      //     let token = sessionStorage.getItem("auth_token");
      //     let url =
      //         domainUrl + `/test/download-test/${item.id}?custom=online&token=${token}`;
      //     //   alert(url);
      //     window.open(url, "_blank");
      // }else{
      this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
      this.alertBoxData = {
        ...item,
        tab: this.tab,
        isOnlineOfflineTest: this.isOnlineOfflineTest,
      };
      this.status = true;
      this.modalwidth = "570px";
      // }
    },
    confirmDeleteTest(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `Are you sure you want to delete the test - ${item.test_name} ?`,
        refId: "deleteTest",
      };
      this.modalwidth = "350px";
      this.status = true;
    },
    deleteTest(test) {
      let postData = {
        test_id: test.id,
      };
      this.$root.showLoader = true;
      this.deleteTestById(postData)
        .then((response) => {
          this.$toasted.success("Test deleted successfully.");
          this.requestGetTestList();
        })
        .catch((err) => {
          // this.$toasted.error('Error deleting test.');
          this.$root.showLoader = false;
        });
    },
    duplicateTest(test) {
      let postData = {
        test_id: test.id,
      };
      this.$root.showLoader = true;
      this.createDuplicateTest(postData)
        .then((response) => {
          this.$toasted.success(
            `Congrats!\nYour test has been Duplicated Successfully and is listed under ${
              test.is_online_test ? "Online" : "Offline"
            } Tests  in Customized Tests.`,
            { icon: "info" }
          );
          this.currentPage = 1;
          this.pageSize = 10;
          this.orderBy = {
            field: "created_at",
            order: "DESC",
          };
          this.requestGetTestList();
        })
        .catch((err) => {
          // this.$toasted.error("Error creating duplicate test.");
          this.$root.showLoader = false;
        });
    },
    editTestName(item) {
      this.currentTestName = _.clone(item.test_name);
      item.editTestName = true;
      clearTimeout(this.singleClickTimer);
      this.singleClickTimer = null;
    },
    saveTestName(testDetails) {
      if (this.currentTestName == testDetails.test_name) {
        testDetails.editTestName = false;
        return;
      }
      if (testDetails.test_name.trim() == "") {
        this.$toasted.error("Test name cannot be blank.");
        return;
      }
      let postData = {
        test_id: testDetails.id,
        test_name: testDetails.test_name,
      };
      this.$root.showLoader = true;
      this.updateTestName(postData)
        .then((response) => {
          this.$toasted.success("Test name updated successfully.");
          testDetails.editTestName = false;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$toasted.error("Error updating test name.");
          testDetails.editTestName = false;
          this.$root.showLoader = false;
        });
    },
    getUserDetails() {
      //   this.me()
      //     .then((response) => {
      this.instituteType = this.user.institute_type;
      this.defaultData();
      // })
      // .catch((err) => {});
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      // if (rp.params.resetPage || !crd.routeName) {
      //     let routeDetails = {
      //         routeName: rp.name,
      //         selectedTab: "default",
      //         tabDetails: {
      //             default: {
      //                 page: 1,
      //                 orderBy: this.orderBy,
      //             },
      //         },
      //     };
      //     this.setRouteDetails(routeDetails);
      // }
    },
    defaultData() {
      this.checkSessionData();
      let routeName = this.$route.name;

      let crd = this.getCurrentRouteDetails(routeName);
      this.requestGetTestList();
      if (crd && crd.tabDetails && crd.selectedTab && crd.tabDetails[crd.selectedTab]) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.requestIds = crd.tabDetails[crd.selectedTab].requestIds;
      }
      
      this.checkDownloadUpdate()
    },
    onClose(data) {
      this.status = data.status;
      if (data.action === "getList" || data.getList) {
        this.requestGetTestList();
      }
      if (data.action === "yes" && data.refId === "deleteTest") {
        this.deleteTest(data.item);
      }
      if (data.action === "yes" && data.refId === "AssignTestDialog") {
        this.confirmationDialogBox(data.item);
      }

      if (data.action === "reloadTestList" || data.realodTest) {  
        this.requestGetTestList();
      }
      if (data.action === "yes" && data.refId === "duplicateTest") {
        this.duplicateTest(data.item);
      }
      if (data.action === "no" && data.refId === "assign-test") {
        this.assignTestDialog(data.item.selectedTest);
      }
      if (data.action === "yes" && data.refId === "assign-test") {
        this.assignTestToTeacher(data.item.postData);
      }

      if (data.data && data.data.base64Image) {
        this.uploadFiles(data.data);
      } else if (data && data.data) {
         const modules = JSON.parse(localStorage.getItem("modules")) || [];
      
      const hasValidQPDModules = modules.some(m => 
        (m.module_id === 14) );
         const hasValidSTModules = modules.some(m => 
        (m.module_id === 15) );
         const hasValidAITSModules = modules.some(m => 
        (m.module_id === 16) );
        let domainUrl = process.env.VUE_APP_API_URL;
        let tab = "online";
        if (hasValidQPDModules && hasValidSTModules && hasValidAITSModules) {
          tab =  "offline";
        } else if (hasValidQPDModules && !hasValidSTModules && hasValidAITSModules) {
          tab = "offline";
        }else if (!hasValidQPDModules && hasValidSTModules) {
         tab = "online";
        }
        if(window.location.href.includes('/past-test-institute')){
          console.log('in past test institute')
          tab = "offline";
        }
        let token = sessionStorage.getItem("auth_token");
        let api = "download-test";
        let query = `custom=${tab}&token=${token}&column=${data.isTwoColumn}&isRoughWork=${data.isRoughWork}&pageBreak=${data.pageBreak}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        if (data.download_option === 2) {
          api = "download-answer-key";
          query = `token=${token}`;
        } else if (data.download_option === 3) {
          api = "download-test-solution";
          query = `custom=${tab}&token=${token}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        } else if (data.download_option === 4) {
          api = "download-omr";
          query = `token=${token}&is_test_id_filled=${data.isTestIDFilled}`;
        }
        if (data.data && data.data.is_test_set == 1) {
          query += `&set_number=${data.selectedSet}`;
        }
        let url = domainUrl + `/test/${api}/${data.data.id}?${query}`;
        if (data.download_option === 2) {
        const currentDateTime = new Date().getTime();
        const testUnlockTime = new Date(data.data.shared_omr_publish_time).getTime()
        if (typeof data.data?.is_shared_test !== 'undefined') {
          window.open(url, "_blank");
        } else {
          if (!(currentDateTime > testUnlockTime)) {
              this.toasts = this.$toasted.error(
                  `You can not download shared test before unlock time ${this.formatDate(testUnlockTime)}`,
                  { icon: "info", duration: null }
              );
              this.toasts.goAway(10000)
          } else {
            window.open(url, "_blank");
          }
        }
        } else {
          this.downloadTestResource(
            `test/${api}/${data.data.id}?${query}`,
            data.data
        );
      }
        //   alert(url);
      }
    },
    downloadTestResource(url, test) {
      this.items.map((item) => {
        if (item.id === test.id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
        }
      });

      this.downloadTestPaper(url)
        .then((res) => {
          this.items.map((item) => {
            if (item.id === test.id) {
              item.request_id = res.request_id;
            }
          });

          if (!this.requestIds.includes(res.request_id)) {
            this.requestIds.push(res.request_id);
          }

          // Display the success toast only after a successful response
          this.toasts[test.id] = this.$toasted.success(
            "PDF creation under progress. Please do not leave this page",
            { icon: "info", duration: null, id: test.id.toString() }
          );

          this.checkDownloadUpdate();
        })
        .catch((err) => {
          this.items.map((item)=>{
            if(item.id === test.id){
              item.status = constants.DOWNLOAD_STATUS.COMPLETED
            }
          })
          console.error("Error:", err);
        });
    },
    checkDownloadUpdate() {
      console.log(this.requestIds, "request_ids");
      if (this.testStatusTimeout) {
			  clearInterval(this.testStatusTimeout);
		  	this.testStatusTimeout = null;
		  }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async(res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if(item.url){
                arr.push({
                  url: data.url,
                  request_id: data.request_id,
                  download_type: data.download_type,
                  test_id: item.id,
                  test_type: this.tab.toLowerCase()
                })
              }
              // this.downloadTestURL(item)
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              this.toasts[item.id].goAway(0)
              delete this.toasts[item.id]

              this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,{icon: 'info'})
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);
            
           await new Promise(resolve => {
            setTimeout(() => {
              resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {
          
       });
    },
    downloadTestURL(item) {
      console.log(item);

      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };
        
        // let typeMapping = {
        //   'Test Paper': 'paper',
        //   'Answer Key': 'answerkey', 
        //   'Solution': 'solution',
        //   'OMR': 'paper'
        // };

        // const downloadData = {
        //   type: 'downloaded',
        //   test_type: this.tab.toLowerCase(),
        //   test_id: item.test_id || item.id,
        //   download_type:  typeMapping[item.download_type] || 'paper',
        // };
        // this.saveInstituteTestDownload(downloadData)
        //   .then((res) => {
        //     console.log('Download data saved successfully:', res);
        //   })
        //   .catch((err) => {
        //     console.error('Error saving download data:', err);
        //   });
        
        item.status = null;
        item.request_id = null;
        item.url = null;

        setTimeout(() => {
          this.deleteDownloadData(reqData)
            .then((res) => {
            })
            .catch((err) => {});
        }, 5000);
      }
    },

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "request_ids":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.request_ids;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    onPreviewClick(test) { 
      if(this.istestPreviewable(test)) return  
      if (test.test_create_status == constants.CUSTOM_TEST_STATUS.CREATED) {
        localStorage.setItem("isOnlineTest", this.tab);
        localStorage.setItem("test", JSON.stringify(test));
        localStorage.setItem("previousPath", this.$route.path);
        if (this.singleClickTimer === null) {
          this.singleClickTimer = setTimeout(() => {
            this.$router.push({
              name: test.instructions
                ? "instructions-about-test"
                : "preview-test",
              params: {
                test_id: test.id,
                test_institute_id: test.test_institute_id,
                test_schedule_id: test.test_schedule_id,
              },
            });
            this.singleClickTimer = null;
          }, 250); // Adjust the delay based on your requirements
        }
      }
    },
    gotoCreateTest(isDummy, test) {
      this.getCustomTestCount({type: test.toLowerCase()})
        .then((response) => {
          if (response && response === true) {
            localStorage.setItem("dummyQuestionTest", isDummy);
            localStorage.setItem("isOnlineTest", test);
            this.$router.push({ name: "create-customized-tests" });
          }
        })
        .catch((err) => {});
    },
     
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    requestGetTestList() {
      this.modules = JSON.parse(localStorage.getItem("modules"));
      let purchasedId = this.modules.find(
        (m) => m.module_id == 9 && m.is_selected == 1
      );

      let reqData = {
        test_types: [4],
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
        test_name: this.testName,
        is_online_test: this.tab === "Online" ? 1 : this.tab === "Offline" ? 0  : undefined,
        aits_list:  1
      };
      //need to be rework
      this.showLoader(true)
        .then((res) => {
          this.$root.showLoader = true;
        })
        .catch((err) => {
          // this.$root.showLoader =true;
        });

      this.getTestList(reqData)
        .then((response) => {
          
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((l) => {
            l.editTestName = false;
            l.delete_disable = l.test_schedule_id ? true : false;
            return l;
          });
          this.setIntervalTime();
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getTestStatus(ids) {
      const reqData = {
        test_ids: ids,
      };
      this.checkTestStatus(reqData)
        .then((response) => {
          this.items.map((t) => {
            let testStatus = response.find((r) => r.id === t.id);
            if (testStatus && testStatus.test_create_status) {
              t.test_create_status = testStatus.test_create_status;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
      }
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    getTestStatusClass(item) {
      if (item.test_schedule_id) {
        return "green-text";
      } else if (item.is_approved === 0) {
        return "yellow-text";
      } else if (item.is_approved) {
        return "blue-text";
      } else {
        return "red-text";
      }
    },
    getCreateTestStatusClass(item) {
      if (item.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED) {
        return "green-text";
      } else if (
        item.test_create_status === constants.CUSTOM_TEST_STATUS.IN_PROGRESS
      ) {
        return "blue-text";
      } else {
        return "red-text";
      }
    },
    getTestStatusText(item) {
      if (item.test_schedule_id) {
        return "Scheduled";
      } else if (item.is_approved === 0) {
        return "Approvals Pending";
      } else if (item.is_approved) {
        return "Approved";
      } else {
        return "Assign";
      }
    },
    getAitsTestStatusText(item) {
      if (item.is_shared_test == 1) {
        if (item.shared_end_time && new Date(item.shared_end_time) < new Date()) {
          return "Finished";
        }
        return "Shared";
      }
    },
    getTestCreationStatusText(item) {
      if (item.test_create_status === constants.CUSTOM_TEST_STATUS.CREATED) {
        return "Completed";
      } else if (
        item.test_create_status === constants.CUSTOM_TEST_STATUS.IN_PROGRESS
      ) {
        return "In Progress";
      } else if (
        item.test_create_status === constants.CUSTOM_TEST_STATUS.FAILED
      ) {
        return "Failed. Click here to Retry.";
      }
    },
    assignTestDialog(item) {
      if (
        item.test_schedule_id ||
        item.test_create_status === constants.CUSTOM_TEST_STATUS.IN_PROGRESS ||
        item.test_create_status === constants.CUSTOM_TEST_STATUS.FAILED
      ) {
        return;
      } else {
        this.selectedTest = item;
        this.cComponent =
          item.is_approved !== null
            ? "components/coordinator/Tests/AssignedTestApprovalStatusDialog"
            : "components/coordinator/Tests/AssignTestDialog";
        this.modalwidth = "800px";
        this.status = true;
        this.alertBoxData = {
          selectedTest: this.selectedTest,
          refId: "AssignTestDialog",
        };
      }
    },
    retryTestDialog(item) {
      if (item.test_create_status !== constants.CUSTOM_TEST_STATUS.FAILED) {
        return;
      } else {
        const reqData = {
          test_id: item.id,
        };
        if (item.test_failed == undefined) {
          item.test_failed = true;
        }
        if (item.test_failed) {
          item.test_failed = false;
          this.customTestRetry(reqData)
            .then((response) => {
              if (response.code !== 102 || response.retry_request_data) {
                this.retryTestData = response.retry_request_data;
                this.createCustomTest();
                item.test_failed = true;
              } else {
                let index = this.items.findIndex(
                  (t) => t.id === reqData.test_id
                );
                if (index >= 0) {
                  this.items[index].test_create_status =
                    constants.CUSTOM_TEST_STATUS.IN_PROGRESS;
                }
                this.setIntervalTime();
                item.test_failed = true;
              }
            })
            .catch((err) => {
              console.log(err);
              item.test_failed = true;
            });
        }
      }
    },
    createCustomTest(questions, optionalQuestionsList, confirmation) {
      // let stepOneData = this.data.stepOneData;
      // let questionTypes = this.data.questionTypes;
      //this.retryTestData.list = this.getQuestionArray(this.retryTestData.list);
      let list = this.createRetryQuestionData(this.retryTestData);
      let forUpdate = false;
      // this.$root.showLoader = true;

      let reqData = { ...this.retryTestData };
      reqData.list = list;
      // if(confirmation){
      reqData.allowed_dummy_question = true;
      // }
      this.customTestRetry(reqData)
        .then((response) => {
          this.$toasted.success(` ${response.msg}`);
          let index = this.items.findIndex((t) => t.id === reqData.test_id);
          if (index >= 0) {
            this.items[index].test_create_status =
              constants.CUSTOM_TEST_STATUS.IN_PROGRESS;
        
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setIntervalTime() {
      if (!timeInterval) {
        timeInterval = setInterval(() => {
          let test_ids = [];
          this.items.map((t) => {
            if (
              t.test_create_status == constants.CUSTOM_TEST_STATUS.IN_PROGRESS
            ) {
              test_ids.push(t.id);
            }
          });
          if (test_ids.length > 0) {
            this.getTestStatus(test_ids);
          } else {
            clearInterval(timeInterval);
            timeInterval = null;
          }
        }, 5000);
      }
    },
    getAnswerType(questionType, subtype) {
      let answerType = 0;

      if (
        questionType == this.QUE_TYPES.COMPREHENSION ||
        questionType == this.QUE_TYPES.TC
      ) {
        answerType = 0; // for questions with subtypes
        if (
          subtype == this.QUE_TYPES.TC_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          this.subQuestionLength = 2;
        } else if (
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          subtype == this.QUE_TYPES.TC_3Q_SA
        ) {
          this.subQuestionLength = 3;
        }
      } else if (
        questionType == this.QUE_TYPES.ASSERTION_REASON ||
        questionType == this.QUE_TYPES.MULTIPLE_CORRECT ||
        questionType == this.QUE_TYPES.SINGLE_CORRECT
      ) {
        answerType = 1; // for questions options
      } else if (
        questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION ||
        questionType == this.QUE_TYPES.MATRIX_MATCH
      ) {
        answerType = 2; // for questions with options, optionsabc, optionspqr
      } else if (
        questionType == this.QUE_TYPES.SUBJECTIVE ||
        questionType == this.QUE_TYPES.SUBJECTIVEINTEGER
      ) {
        answerType = 3; // for subjective type questions
      } else if (questionType == this.QUE_TYPES.INTEGER) {
        answerType = 4; // for integer type questions
      }
      return answerType;
    },
    ScheduleTestDialog(item) {
      if (item.test_create_status == constants.CUSTOM_TEST_STATUS.CREATED) {
        this.selectedTest = item;
        this.cComponent = "components/coordinator/Tests/ScheduleTestPopup";
        this.modalwidth = "1000px";
        this.status = true;
        this.alertBoxData = {
          selectedTest: this.selectedTest,
          isOnlineTest: this.tab === constants.ONLINE_TEST_TAB ? true : false,
        };
      }
    },
    ShareTestDialog(item) {
      if(item.is_shared_test) return
      if (item.test_create_status == constants.CUSTOM_TEST_STATUS.CREATED) {
        this.selectedTest = item;
        this.cComponent = "components/coordinator/Tests/ShareTestPopup";
        this.modalwidth = "1000px";
        this.status = true;
        this.alertBoxData = {
          selectedTest: this.selectedTest,
          // isOnlineTest: this.tab === constants.ONLINE_TEST_TAB ? true : false,
        };
      }
    },
    onSearchTest() {
      this.resetFields();
      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.requestGetTestList();
      }, 1500);
      //   this.updateRouteDetails({ searchText: this.testName });
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
    resetTimer() {
      clearInterval(timeInterval);
      // clearTimeout(this.typetimeout)
    },
    onUpload() {
      this.cComponent = "components/coordinator/Tests/UploadOmrSheet";
      this.status = true;
      this.modalwidth = "500px";
    },
    capture() {
      this.cComponent = "components/OmrCamera";
      this.modalwidth = "600px";
      this.alertBoxData = { btn_text: "Submit" };
      this.status = true;
      this.$forceUpdate();
    },

    validation() {
      let valid = true;
      for (let index = 0; index < this.files.length; index++) {
        const file = this.files[index];
        if (!this.OMR_SUPPORTED_FILE_TYPES.includes(file.type)) {
          valid = false;
          this.$toasted.error(`File type not supported of file ${file.name}`, {
            icon: "info",
          });
          break;
        }
      }
      return valid;
    },
    uploadFiles(data) {
      const files = this.files;
      const formData = new FormData();
      this.$root.showLoader = true;
      const file = this.dataURLtoFile(
        data.base64Image,
        `OMR-${this.myInstitute.id}-${moment().format("X")}.jpeg`
      );
      formData.append("image", file);

      formData.append("institute_id", this.myInstitute.id);
      this.uploadOmr(formData)
        .then((res) => {
          this.$toasted.success("Omr uploaded successfully!", { icon: "info" });
          this.$root.showLoader = false;
          this.onClose({ status: false });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    assignTestToTeacher(postData) {
      this.$root.showLoader = true;

      this.assignTest(postData)
        .then((response) => {
          this.$root.showLoader = false;
          this.$toasted.success(response.message);
          this.requestGetTestList();
        })
        .catch((err) => {
          this.$toasted.error("Error assigning test to teachers.");
          this.$root.showLoader = false;
        });
    },
     getCurrentUser(){
      let instituteData = JSON.parse(localStorage.getItem("myInstitute"));
      this.instituteId = instituteData?.id
      
    },
    checkModuleAccess() {
      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      const currentDate = new Date();
      
      // Check QPD module (module_id: 14) - for Offline
      const qpdModule = modules.find(m => m.module_id === 14 && m.is_selected === 1);
      this.hasQPDAccess = qpdModule && new Date(qpdModule.expiry_date) > currentDate;
      
      // Check ST module (module_id: 15) - for Online  
      const stModule = modules.find(m => m.module_id === 15 && m.is_selected === 1);
      this.hasSTAccess = stModule && new Date(stModule.expiry_date) > currentDate;

       const aitsModule = modules.find(m => m.module_id === 16 && m.is_selected === 1);
      this.aitsModule = aitsModule;
      
      // Set schedule button visibility
      this.setScheduleButtonVisibility();
    },
    setScheduleButtonVisibility() {
      if (this.hasQPDAccess && this.hasSTAccess) {
        // Both modules - show schedule in both online and offline
        this.showScheduleButton = true;
      } else if (this.hasSTAccess && !this.hasQPDAccess) {
        // Only ST module - show schedule only in online tab
        this.showScheduleButton = true;
      } else if(this.aitsModule && this.hasQPDAccess && !this.hasSTAccess){
        this.showScheduleButton = true;

      } else {
        // Only QPD or no modules - don't show schedule
        this.showScheduleButton = false;
      }
    },
    getStatusClass(item) {
      const text = this.getAitsTestStatusText(item);
      if (text === "Finished") {
        return "finished";
      } else if (text === "Shared") {
        return "shared";
      }
      return "";
    }
  },
  watch: {
    buttonHovering(val) {
      this.showToolTip = val;
    },
    tab(val) {
      
      
      if (val === this.value) {
        this.setScheduleButtonVisibility();
        this.requestGetTestList();
      }
    },
    requestIds(val) {
      let routeName = this.$route.name;
      this.updateRouteDetails({
        type: "request_ids",
        data: { request_ids: val },
      });
    },
   
  },
  beforeDestroy() {
    clearInterval(timeInterval);
    timeInterval = null;
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  },
};
</script>

<style scoped>
.blue-share {
  color:blue; /* Text color */
}
.finished {
  color: green;
}
.shared {
  color: orange;
}
.disabled {
  pointer-events: none; /* Prevents interaction */        /* Makes it look disabled */
  cursor: not-allowed;  /* Changes the cursor to indicate it is disabled */
}
</style>

